import AcxSelectSingle from "components/UI/Select/BaseSelectComponents/AcxSelectSingle";
import { observer } from "mobx-react";
import { LLMExecutorStep } from "models/LLMs";
import { LLMConstants } from "models/LLMs/constants";
import React from "react";

type StepSelectorProps = {
    selectedStepId: string;
    thisStepId: string;
    steps: LLMExecutorStep[];
    onChange?: (step: LLMExecutorStep | undefined, isStatic: boolean) => void;
};

export const StepSelector = observer(function (props: StepSelectorProps) {
    const options = props.steps
        .map((step) => {
            const isDefaultStep = step.id === props.thisStepId;

            if (isDefaultStep)
                return {
                    label: "Step: This step (" + step.name + ")",
                    value: step.id,
                };
            return {
                label: "Step: " + step.name,
                value: step.id,
            };
        })
        .concat({
            label: "Assign static value",
            value: LLMConstants.StaticValueVariablePrefix,
        });
    const currentStep = options.find(
        (option) => option.value === props.selectedStepId,
    )!;

    return (
        <AcxSelectSingle
            id=""
            fullWidth
            labelField="label"
            valueField="value"
            options={options}
            defaultValue={currentStep}
            onChange={(step) => {
                const isStatic =
                    step.value === LLMConstants.StaticValueVariablePrefix;
                if (isStatic) {
                    props.onChange?.(undefined, true);
                } else {
                    props.onChange?.(
                        props.steps.find((s) => s.id === step.value)!,
                        false,
                    );
                }
            }}
        />
    );
});
